<template>
</template>
<script>
import mixinComponent from '../mixins';

export default {
    mixins: [mixinComponent]
}
</script>
